/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_New_HeadingInputs */

const en_jobs_new_heading = /** @type {(inputs: Jobs_New_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New job`)
};

const he_jobs_new_heading = /** @type {(inputs: Jobs_New_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`משימה חדשה`)
};

/**
* | output |
* | --- |
* | "New job" |
*
* @param {Jobs_New_HeadingInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const jobs_new_heading = /** @type {((inputs?: Jobs_New_HeadingInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_New_HeadingInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_jobs_new_heading(inputs)
	return he_jobs_new_heading(inputs)
});